export default "__VITE_ASSET__DYn77ARs__"